$(function() {

	$('.js-carousel').on('init', function(event, slick, currentSlide, nextSlide){
		var $this = $(this);

	    $this.find('video').each(function(){
	    	$(this)[0].play();
	    });
	});

	$('.js-carousel').on('afterChange', function(event, slick, currentSlide, nextSlide) {
		$this = $(this);
	    $this.find(".slick-current video").each(function(){
	    	$(this)[0].play();
	    });
	});

	$('.js-carousel').slick({
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		slidesToScroll: 1,
		pauseOnHover: false,
		fade:true
	});

	$('.js-blog-featured-posts').slick({
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		slidesToScroll: 1,
		pauseOnHover: false,
		fade:true,
		arrows: false
	});

	$('.js-home-intro').slick({
		dots: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 60000,
		speed: 800,
		arrows:false,
		slidesToShow: 1,
		adaptiveHeight: false,
		customPaging : function(slider, i) {
			return '<button>0'+(i+1)+'.</button>';
		}
	});

    var brandLogoSlider = new Swiper('.brand-logo-slider__container', {
        slidesPerView : 5,
        loop: true,
        speed: 1000,
        watchSlidesVisibility: true,
        spaceBetween : 30,
        autoplay: {
            delay: 3000,
        },
       
        // Responsive breakpoints
        breakpoints: {
            1499:{
                slidesPerView : 5
            },

            991:{
                slidesPerView : 3
            },

            767:{
                slidesPerView : 3

            },

            575:{
                slidesPerView : 2
            }
        }
    });
});